import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Option } from '../../engine/models/models';
import { GlobalOptionModel } from '../../models/GlobalOptionModel';
import { InspirationRoomOptionModel } from '../../models/InspirationRoomOptionModel';
import { InspirationRoomTipsModel } from '../../models/InspirationRoomTipsModel';


@Injectable()
export class OptionSelectorService {
  addTip = new Subject<InspirationRoomTipsModel>();
  optionAdded = new Subject<InspirationRoomOptionModel>();
  refreshOption = new Subject<number[]>();
  updateJson = new Subject<any>();
  constructor(private http: HttpClient) {

  }

  refreshDeletedOption(optionIds: number[]) {
    this.refreshOption.next(optionIds);
  }
  loadOption(value: InspirationRoomOptionModel) {
    this.optionAdded.next(value);
  }
  loadTip(value: InspirationRoomTipsModel) {
    this.addTip.next(value);
  }
  onUpdateJson(value: any) {
    this.updateJson.next(value);
  }

  getGlobalOptions(isRefresh: boolean) {
    return this.http.get<Option[]>(`${environment.api}/api/GlobalOptions/${isRefresh}`);
  }

  getInspirationRoomsOptions() {
    return this.http.get<InspirationRoomOptionModel[]>(`${environment.api}/api/InspirationRoom/GetOptions`);
  }

  updateDisplayOrder(model: any[]) {
    return this.http.put<any>(`${environment.api}/api/InspirationRoom/displayOrder`, model);
  }

  deleteOptions(id: number) {
    return this.http.delete<GlobalOptionModel[]>(`${environment.api}/api/InspirationRoom/${id}`);
  }
  deleteMultipleOptions(model: any) {
    return this.http.post<boolean>(`${environment.api}/api/InspirationRoom/deleteOptions`, model);
  }

  deleteTip(id: number) {
    return this.http.delete<GlobalOptionModel[]>(`${environment.api}/api/InspirationRoom/deleteTip/${id}`);
  }

}
